import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const CustomerTierIcon = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				ref={ref}
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="currentColor"
				role="img"
				focusable="false"
				aria-hidden="true"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
				{...props}
			>
				<path d="M8.24906 14.8546C8.09534 14.9424 7.9066 14.9424 7.75286 14.8546L1.23033 11.1271C1.10716 11.0567 1.0716 10.8954 1.15374 10.7798L2.66183 8.65631L7.64044 11.3719C7.8643 11.494 8.13486 11.494 8.35872 11.3719L13.3387 8.65556L14.8471 10.7798C14.9292 10.8954 14.8936 11.0567 14.7705 11.1271L8.24906 14.8546Z"></path>
				<path d="M12.7557 7.83449L7.99958 10.4287L3.24493 7.83527L4.89862 5.5068L7.66417 6.88958C7.87531 6.99515 8.12384 6.99515 8.33499 6.88958L11.1022 5.50596L12.7557 7.83449Z"></path>
				<path d="M10.5163 4.68087L7.99958 5.93925L5.48457 4.68174L7.79713 1.42555C7.89679 1.28522 8.10514 1.28523 8.20479 1.42557L10.5163 4.68087Z"></path>
			</svg>
		)
	},
)

export const CustomerRevenueIcon = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				ref={ref}
				width="16"
				height="16"
				viewBox="0 0 16 16"
				role="img"
				focusable="false"
				aria-hidden="true"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
				fill="currentColor"
				{...props}
			>
				<path d="M10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z"></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M1 4.25C1 3.55964 1.55964 3 2.25 3H13.75C14.4404 3 15 3.55964 15 4.25V11.75C15 12.4404 14.4404 13 13.75 13H2.25C1.55964 13 1 12.4404 1 11.75V4.25ZM2.5 9.03023V6.96977C3.35337 6.81302 4 6.06536 4 5.16667V4.5H12V5.16667C12 6.06536 12.6466 6.81302 13.5 6.96977V9.03023C12.6466 9.18698 12 9.93464 12 10.8333V11.5H4V10.8333C4 9.93464 3.35337 9.18698 2.5 9.03023Z"
				></path>
			</svg>
		)
	},
)

export const CustomerSizeIcon = forwardRef<SVGSVGElement, Props>(
	({ className, ...props }, ref) => {
		return (
			<svg
				ref={ref}
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="currentColor"
				role="img"
				focusable="false"
				aria-hidden="true"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
				{...props}
			>
				<path d="M7.5 1C7.22386 1 7 1.22386 7 1.5V4C7 4.27614 7.22386 4.5 7.5 4.5H8.5C8.77614 4.5 9 4.27614 9 4V1.5C9 1.22386 8.77614 1 8.5 1H7.5Z"></path>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.5 3H5.5C5.77614 3 6 3.22386 6 3.5V4H5.75C5.33579 4 5 4.33579 5 4.75C5 5.16421 5.33579 5.5 5.75 5.5H10.25C10.6642 5.5 11 5.16421 11 4.75C11 4.33579 10.6642 4 10.25 4H10V3.5C10 3.22386 10.2239 3 10.5 3H11.5C12.3284 3 13 3.67157 13 4.5V13.5C13 14.3284 12.3284 15 11.5 15H4.5C3.67157 15 3 14.3284 3 13.5V4.5C3 3.67157 3.67157 3 4.5 3ZM9.5 8.5C9.5 9.32843 8.82843 10 8 10C7.17157 10 6.5 9.32843 6.5 8.5C6.5 7.67157 7.17157 7 8 7C8.82843 7 9.5 7.67157 9.5 8.5ZM7 11C5.89543 11 5 11.8954 5 13C5 13.2761 5.22386 13.5 5.5 13.5H10.5C10.7761 13.5 11 13.2761 11 13C11 11.8954 10.1046 11 9 11H7Z"
				></path>
			</svg>
		)
	},
)
